export const GUIDE_LIST_ITEM_KIND = {
  CATEGORY: 'CATEGORY',
  CHANNEL: 'CHANNEL',
  AD: 'AD',
};
